import { render } from "./Leave.vue?vue&type=template&id=738d01a8&scoped=true"
import script from "./Leave.vue?vue&type=script&lang=js"
export * from "./Leave.vue?vue&type=script&lang=js"

import "./Leave.vue?vue&type=style&index=0&id=738d01a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-738d01a8"]])

export default __exports__